import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-card-collapse',
  templateUrl: './card-collapse.component.html',
  styleUrls: ['./card-collapse.component.scss']
})
export class CardCollapseComponent implements OnInit {

  @ViewChild('cardBody', { static: true }) cardBody: ElementRef;
  @ViewChild('cardBodyContainer', { static: true }) cardBodyContainer: ElementRef;

  @Input() titleColor = 'theme';
  @Input() cardHeaderClass = '';
  @Input() cardBodyClass = '';
  @Input() show = true;
  @Input() title = '';

  constructor() { }

  ngOnInit() { }

  ngAfterViewChecked() {
    if(this.show) {
      this.cardBodyContainer.nativeElement.style.height = 'auto';
    }
  }

  resize() {
    if(this.show) {
      this.cardBodyContainer.nativeElement.style.height = 'auto';
    } else {
      this.cardBodyContainer.nativeElement.style.height = '0px';
    }
  }

  click() {
    this.show = !this.show;
    this.resize();
  }

}
